/** @format */
import React from 'react';
import PropTypes from 'prop-types';

const SubscriptionCardIcon = ({ 
  className = "h-7 w-7", 
  count = null,
  showPinkAccent = false,
  isActive = true 
}) => {
  return (
    <div className="relative">
      <svg 
        className={className} 
        viewBox="0 0 32 32" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Subscription card icon with active status"
      >
        {/* Credit card base */}
        <rect 
          x="4" 
          y="8" 
          width="24" 
          height="16" 
          rx="3" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          fill="none"
        />
        
        {/* Magnetic stripe */}
        <rect 
          x="4" 
          y="12" 
          width="24" 
          height="3" 
          fill="currentColor" 
          opacity="0.7"
        />
        
        {/* Chip */}
        <rect 
          x="7" 
          y="16" 
          width="4" 
          height="3" 
          rx="0.5" 
          fill="currentColor" 
          opacity="0.8"
        />
        
        {/* Card numbers (stylized dots) */}
        <g opacity="0.6">
          <circle cx="14" cy="17.5" r="0.8" fill="currentColor" />
          <circle cx="16.5" cy="17.5" r="0.8" fill="currentColor" />
          <circle cx="19" cy="17.5" r="0.8" fill="currentColor" />
          <circle cx="21.5" cy="17.5" r="0.8" fill="currentColor" />
        </g>
        
        {/* Premium/luxury detail - small diamond */}
        <path
          d="M24 19 L25.5 20.5 L24 22 L22.5 20.5 Z"
          fill={showPinkAccent ? "#CC1DB9" : "currentColor"}
          opacity={showPinkAccent ? "1" : "0.7"}
        />
        
        {/* Subscription indicator - recurring symbol */}
        <path
          d="M7 20.5 A1.5 1.5 0 0 1 10 20.5"
          stroke="currentColor"
          strokeWidth="1"
          fill="none"
          strokeLinecap="round"
          opacity="0.8"
        />
        
        <path
          d="M8.5 19 L7 20.5 L8.5 22"
          stroke="currentColor"
          strokeWidth="1"
          fill="none"
          strokeLinecap="round"
          opacity="0.8"
        />
      </svg>
      
      {/* Active subscription indicator */}
      {isActive && (
        <div className="absolute -top-0.5 -right-0.5 w-3 h-3 bg-green-500 rounded-full border-2 border-white">
        </div>
      )}
      
      {/* Contextual count overlay */}
      {count !== null && (
        <div className="absolute -top-1 -right-1 bg-primary text-white text-xs font-montserrat-medium rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
          {count}
        </div>
      )}
    </div>
  );
};

SubscriptionCardIcon.propTypes = {
  className: PropTypes.string,
  count: PropTypes.number,
  showPinkAccent: PropTypes.bool,
  isActive: PropTypes.bool,
};

export default SubscriptionCardIcon;